// Types
import { StoreGender } from 'api/graphql-global-types';
// Constants
import { GENDER_OPTIONS, StoreGenderOptionsType } from 'constants/store';

/**
 * Maps a saved gender to one of the selectable options (Male/Female).
 * Legacy values (e.g. "other", "preferNotToSay") return null so the
 * user is forced to pick again.
 */
export const getGenderOption = (
  gender?: StoreGender | null
): StoreGenderOptionsType | null =>
  GENDER_OPTIONS.find((option) => option.value === gender) || null;
